﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconLicense } from "@tabler/icons-react";


export const MotivosLicenciaIcon = IconLicense;
export const MotivosLicenciaHelpText = '* Aquí puede ver la lista de los motivos de licencia.';

export class catMotivosLicencia extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "MotivosLicencia";
        this.def.columns.c_category_id.defaultValue = "MotivosLicencia";
        this.Title = "Motivos de Licencia";     
        this.Icon = MotivosLicenciaIcon;
        this.HelpText = MotivosLicenciaHelpText;
    }
}